export default __webpack_public_path__ + "static/media/doctor-1.6c4551ae.jpg";